import React from 'react'

import VerticalToggle from '../VerticalToggle'

const HorizontalToggle = ({ name, selected, onChange, options }) => (
  <VerticalToggle
    name={name}
    selected={selected}
    onChange={onChange}
    options={options}
    style={{ flexDirection: 'row', justifyContent: 'center' }}
  />
)

export default HorizontalToggle
